<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 68px;"></div>
		<div class="special">
			<div>
				<div class="designer-warp1">
					<div :class="arrange == false?'colorE66617':'color333333'" @click="arrangement('one')">按销量排列</div>
					<div :class="arrange == true?'colorE66617':'color333333'" @click="arrangement('two')">按上传数量排列</div>
				</div>
			</div>
			
			<div class="special-content">
				<div class="special-item1" v-for="(item, index) in designers" :key="index" @click="goAuthor(item.users_id)">
					<div>
						<img :src="imageUrl(item.head_pic)" :alt="'以图绘图印花设计网-' + item.nickname">
					</div>
					<div class="name">{{ item.nickname }}</div>
					<div class="more">查看更多</div>
				</div>
			</div>
		</div>
		<info />
		<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
		<foot />
	</div>
</template>

<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import { openAreaData,checkOriginalAuth,designer } from "../../request/api";
	export default {
		components: {
			top,
			foot,
			info
		},
		data() {
			return {
				value1: '',
				value: '',
				count: 30,
				size: 20,
				page: 1,
				arctype: "", //分类
				choose_type: [],
				list:'',
				arrange:false,
				designers: [], //新锐设计师
			};
		},
		created() {
			document.title = '以图绘图印花设计网-设计师';
			this.getDesigner()
		},
		methods: {
			arrangement(num) {
				this.arrange = !this.arrange
				this.getDesigner()
			},
			//新锐设计师
			getDesigner() {
				designer({
					order_field:this.arrange == false?'o_count':'a_count'
				}).then((res) => {
					console.log(res);
					
					this.designers = res.data;
				});
			},
			goAuthor(author_id) {
			  this.$router.push({
			    name: 'Author',
			    query: {
			      author_id: author_id,
			    },
			  });
			},
		},
	};
</script>

<style lang="less">
	.page {
		background: #F6F6F6;
		.special {
			width: 96%;
			margin: 0 auto;
			margin-top: 20px;
			.special-warp {
				display: flex;
				align-items: center;
				margin-bottom: 10px;
			}
		
			.special-warp div:first-child {
				font-size: 16px;
				font-weight: 400;
				color: #333333;
			}
		
			.special-warp div:first-child::after {
				content: "/";
				font-size: 12px;
				font-weight: 400;
				color: #afafaf;
				padding: 0 8px;
			}
		
			.special-warp div:last-child {
				font-size: 12px;
		
				font-weight: 400;
				color: #afafaf;
			}
		
			.special-content {
				padding-top: 24px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap:wrap;
				.special-item {
					margin-bottom: 10px;
					width: 48%;
					height: 185px;
					background: #ffffff;
					border-radius: 3px;
					cursor: pointer;
		
					img {
						width: 100%;
						height: 154px;
						display: block;
					}
		
					.special-text {
						background-color: #ffffff;
						font-size: 12px;
						font-weight: 400;
						color: #333333;
						text-align: center;
						line-height: 31px;
					}
				}
				.special-item1 {
					margin-bottom: 10px;
					width: 48%;
					height: 195px;
					background: #ffffff;
					border-radius: 3px;
					cursor: pointer;
					text-align: center;
					img {
						border-radius: 50%;
						width: 74px;
						height: 74px;
						margin-top: 15px;
					}
					.name {
						font-size: 12px;
						margin-top: 20px;
						color: #08243C;
					}
					.more {
						margin: 0 auto;
						width: 60px;
						border: 1px solid #D2D7DC;
						border-radius: 10px;
						padding: 5px 15px;
						font-size: 12px;
						margin-top: 30px;
						color: #E66617;
					}
				}
			}
		}
		.colorE66617 {
			color: #E66617;
		}
		.color333333 {
			color: #333333;
		}
		.designer-warp1 {
			display: flex;
			align-items: center;
		}
		
		.designer-warp1 div:first-child {
			font-size: 14px;
			font-weight: 400;
			// color: #E66617;
			line-height: 24px;
		}
		
		.designer-warp1 div:first-child::after {
			content: "|";
			font-size: 11px;
			font-weight: 400;
			color: #888888;
			padding: 0 12px;
		}
		
		.designer-warp1 div:last-child {
			font-size:14px;
		
			font-weight: 400;
			// color: #333333;
			line-height: 16px;
		}
		.mid2 {
			padding: 0 9px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
		}
		.bottom2 {
			padding: 10px;
			
			.bottomimg {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				img {
					width: 170px;
					height: 170px;
					margin-bottom: 10px;
				}
			}
			.page {
				position: relative;
				left: -15%;
				transform: scale(0.7);
			}
		}

	}
</style>
